import { TIMELINE_MODES } from '../../helpers/calendar/timelineResources'

/**
 * De schakelaar boven het rooster: staan de medewerkers links onder elkaar, of
 * de huishoudens.
 *
 * @param {object} props
 * @param {'personas'|'adresses'} props.mode - Wat er nu links staat
 * @param {(mode: 'personas'|'adresses') => void} props.onChange - Aangeroepen bij een klik
 */
const TimelineModeSwitch = ({ mode, onChange }) => (
    <div className="calendar-timeline-switch" role="group" aria-label="Rijen van het rooster">
        <button
            type="button"
            className={mode === TIMELINE_MODES.personas ? 'is-active' : ''}
            onClick={() => onChange(TIMELINE_MODES.personas)}
        >
            Per medewerker
        </button>
        <button
            type="button"
            className={mode === TIMELINE_MODES.adresses ? 'is-active' : ''}
            onClick={() => onChange(TIMELINE_MODES.adresses)}
        >
            Per huishouden
        </button>
    </div>
)

export default TimelineModeSwitch
